import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={9}
      height={9}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M4.5 0a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm.016 7.42c-.503.243-1.28.034-1.144-.472l.733-2.736c.256-.957-.449-.643-.765-.505.193-.29.46-.523.775-.676.502-.242 1.28-.033 1.144.473l-.733 2.735c-.257.957.449.644.764.505-.193.29-.46.524-.774.676zm1.129-5.356a.466.466 0 11-.9-.241.466.466 0 01.9.241z"
        fill="#4874FE"
      />
    </Svg>
  );
}

export default SvgComponent;
